<template>
    <img v-if="row.bank_name" :src="BankLogo(row.bank_name)" width="42" height="32">
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    }
})
</script>

<style>

</style>